import { t } from '@/i18n';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// featureを跨いで使用するenumを定義する
/// ////////////////////////////////////////////

// Project

export const sheetTypeEnum = z.enum(['RS', 'SS', 'KS']);
export const SheetTypeLabelModifier = {
  RS: t('review-sheet'),
  SS: t('segment-sheet'),
  KS: t('fund-sheet'),
} as const satisfies Record<z.infer<typeof sheetTypeEnum>, string>;

export const fundSheetTypeEnum = z.enum([
  'standard',
  'local-government',
  'investment',
]);
export const FundSheetTypeBefore2025LabelModifier = {
  standard: t('fund-sheet'),
  'local-government': t('local-government-fund-sheet-before-2025'),
  investment: t('investment-fund-sheet'),
} as const satisfies Record<z.infer<typeof fundSheetTypeEnum>, string>;
export const FundSheetTypeLabelModifier = {
  standard: t('fund-sheet'),
  'local-government': t('local-government-fund-sheet'),
  investment: t('investment-fund-sheet'),
} as const satisfies Record<z.infer<typeof fundSheetTypeEnum>, string>;

export const projectCategoryEnum = z.enum([
  'continuation',
  'new',
  'requesting',
]);
export const ProjectCategoryLabelModifier = {
  continuation: t('project-category-continuation'),
  new: t('project-category-new'),
  requesting: t('project-category-requesting'),
} as const satisfies Record<z.infer<typeof projectCategoryEnum>, string>;

export const implementationMethodEnum = z.enum([
  'direct',
  'subsidy',
  'burden',
  'grant',
  'contribution',
  'others',
]);
export const ImplementationMethodLabelModifier = {
  direct: t('implementation-method-direct'),
  subsidy: t('implementation-method-subsidy'),
  burden: t('implementation-method-burden'),
  grant: t('implementation-method-grant'),
  contribution: t('implementation-method-contribution'),
  others: t('implementation-method-others'),
} as const satisfies Record<z.infer<typeof implementationMethodEnum>, string>;

export const reviewTypeEnum = z.enum([
  'public-process',
  'document',
  'unnecessary',
]);
export const ReviewTypeLabelModifier = {
  'public-process': t('review-type-public-process'),
  document: t('review-type-document'),
  unnecessary: t('review-type-unnecessary'),
} as const satisfies Record<z.infer<typeof reviewTypeEnum>, string>;

// Analysis
export const analysisTargetEnum = z.enum(['expenditure', 'payment']);
const _AnalysisTargetLabelModifier = {
  expenditure: t('expenditure-item'),
  payment: t('analysis-payment-tab-label'),
} as const satisfies Record<z.infer<typeof analysisTargetEnum>, string>;

export const aggregationTypeEnum = z.enum([
  'finalized',
  'finalizedForInitialBudget',
  'finalizedForSupplementaryBudget',
  'finalizedForSupplementaryBudget_1',
  'finalizedForSupplementaryBudget_2',
  'finalizedForSupplementaryBudget_3',
  'finalizedForSupplementaryBudget_4',
  'finalizedForSupplementaryBudget_5',
  'finalizedForReserveBudget',
  'finalizedForCarriedForwardBudget',
  'payment',
]);
const _AggregationTypeLabelModifier = {
  finalized: t('expenditure-item'),
  finalizedForInitialBudget: t('initial-budget'),
  finalizedForSupplementaryBudget: t('supplementary-budget'),
  finalizedForSupplementaryBudget_1: t('supplementary1-budget'),
  finalizedForSupplementaryBudget_2: t('supplementary2-budget'),
  finalizedForSupplementaryBudget_3: t('supplementary3-budget'),
  finalizedForSupplementaryBudget_4: t('supplementary4-budget'),
  finalizedForSupplementaryBudget_5: t('supplementary5-budget'),
  finalizedForReserveBudget: t('reserve-budget'),
  finalizedForCarriedForwardBudget: t('carry-over-finalized-amount'),
  payment: t('amount-of-expenditures'),
} as const satisfies Record<z.infer<typeof aggregationTypeEnum>, string>;

export const aggregationTargetTypeEnum = z.enum([
  'total',
  'general',
  'special',
]);
const _AggregationTargetTypeLabelModifier = {
  total: t('total'),
  general: t('general-account'),
  special: t('special-account'),
} as const satisfies Record<z.infer<typeof aggregationTargetTypeEnum>, string>;

export const analysisAxisEnum = z.enum(['organization', 'year', 'policy']);
const _AnalysisAxisLabelModifier = {
  organization: t('organization-in-charge'),
  year: '',
  policy: t('policy'),
} as const satisfies Record<z.infer<typeof analysisAxisEnum>, string>;
